export const version = '2.67.3';
//# sourceMappingURL=version.js.map